export const connectWallet = async () => {
  if (window.ethereum) {
    try {
        const addressArray = await window.ethereum.request({
        method: "eth_requestAccounts",
      });
      const obj = {
        message: "Connected to Polygon ✅",
        address: addressArray[0]
      };
      return obj;
    } catch (err) {
      return {
        address: "",
        message: "Check your Metamask wallet...",
      };
    }
  } else {
    return {
      address: "",
      message: (
        <span>
          <p>
            {" "}
            🦊{" "}
            <a target="_blank" rel="noreferrer" href={`https://metamask.io/download.html`}>
            You must install Metamask.
            </a>
          </p>
        </span>
      )
    };
  }
};



